export const Routes = {
  Home: '/',
  NotFound: '/404',
};
